import * as Select from '@radix-ui/react-select'
import { usePortalContainerRef } from '../portal/portal-container'

// oxlint-disable-next-line cf-web/no-barrel-file -- eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@radix-ui/react-select'

/**
 * Selects opened from inside a `Dialog.Body` (e.g. the batch selector's "Add another model" —
 * `@repo/studio-components-common` select) default-portal to `document.body`, landing outside the
 * dialog's own content node. Radix's `Dialog.Content` dismisses on any outside pointerdown, so a
 * click on that body-portaled content reads as "outside the dialog" and closes it. An ancestor
 * `PortalContainerProvider` (set up by `primitives/dialog`) lets this render inside the dialog's
 * content DOM instead — explicit `container` still wins.
 */
export function Portal({ container: containerProp, ...props }: Select.SelectPortalProps) {
  const portalContainerRef = usePortalContainerRef()
  const container = containerProp ?? portalContainerRef?.current ?? undefined

  return <Select.Portal container={container} {...props} />
}
